import {
  TriggerForm,
  TriggerFormValues,
} from "@/components/knowledge-base/trigger-form";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCreateTrigger } from "@/lib/api/triggers-knowledge-base";

export const Route = createFileRoute("/_authenticated/knowledge-base/new")({
  component: NewTrigger,
});

function NewTrigger() {
  const navigate = useNavigate();
  const { mutateAsync: createTrigger, isPending } = useCreateTrigger();

  const handleSubmit = async (values: TriggerFormValues) => {
    try {
      await createTrigger(values);
      navigate({ to: "/knowledge-base" });
    } catch (error) {
      console.error("Error creating trigger:", error);
    }
  };

  return (
    <div className="m-6 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Create New Trigger</h1>
        <p className="mt-2 text-sm text-gray-500">
          Add a new trigger to the knowledge base.
        </p>
      </div>

      <div className="rounded-lg border bg-card p-6">
        <TriggerForm onSubmit={handleSubmit} isSubmitting={isPending} />
      </div>
    </div>
  );
}
